
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggynj_J8dUDFotIXWJReA5LUsE_45gdunY1Gwgn9aJ_Oe4Meta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexbAxbxRwBAYWsD2qxOUQOcSh8JzT6EvRF6qW8u_45XSuewMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchpfKdqudBJfSZI4_45XHPCBdytGn4as9_45WTU80x_kRkmY4Meta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index9QBZCJbKScjTILlVe5yMZupFgrL1fUMTCkVDrrRSaH0Meta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93RBvSQQqGx_okvaklVpgNPejlw6slbvUHLw28Y5G3l7cMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexIpc_w6CXQfPqwGpUQqcAB6WOzNRJ0aVgfrEy86_45f9JoMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93z9gle9jwOE3IoP335MiJ_2lzvdonDEXcAHO5XOQqyZ0Meta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexpZMt1mNmiEBtSoo0Z_45BY6_KWiXIxMbcDWxLLG4YMUlIMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_938CHcS8kz3OTY1AgvwfO39KdaUHqI5mR8RDgEzkvcb3oMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexenF0SF6JTkf_45BlNj1DTR_AgWa2xy5_yTkLhk4aTvVAMMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexF9b7mW4rDIzfY3mfsBr_I2CViFTmwvFPyaUMKgI3YOIMeta } from "/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexIpc_w6CXQfPqwGpUQqcAB6WOzNRJ0aVgfrEy86_45f9JoMeta || {},
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexpZMt1mNmiEBtSoo0Z_45BY6_KWiXIxMbcDWxLLG4YMUlIMeta || {},
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexenF0SF6JTkf_45BlNj1DTR_AgWa2xy5_yTkLhk4aTvVAMMeta || {},
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexF9b7mW4rDIzfY3mfsBr_I2CViFTmwvFPyaUMKgI3YOIMeta || {},
    component: () => import("/codebuild/output/src1591503220/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]